import type { CashAndBankRepository } from "../repositories/CashAndBankRepository";
import type { ReconciliationStatusEntity } from "../entities/ReconciliationStatusEntity";
import type { GetReconciliationStatusParams } from "../repositories/CashAndBankRepository";

export class GetReconciliationStatusUseCase {
  constructor(private readonly repository: CashAndBankRepository) {}

  async execute(
    params: GetReconciliationStatusParams
  ): Promise<ReconciliationStatusEntity> {
    return this.repository.getReconciliationStatus(params);
  }
}
